import styled from 'styled-components';
import { baseVariables } from '../../styles';

const { spacers } = baseVariables;

export const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${spacers?.spacers?.[1]};
`;
